import axios from "axios";

export default class Palyance {
  static getAspspEligibility(
    walletIdentifier,
    paymentType,
    merchantIdentifier,
  ) {
    const url = `${process.env.VUE_APP_PALYANCE_API_BASE_URL}/eligibility/aspsp?walletIdentifier=${encodeURIComponent(walletIdentifier)}&paymentType=${encodeURIComponent(paymentType)}&merchantIdentifier=${encodeURIComponent(merchantIdentifier)}`;

    return axios.get(url).then(({ data }) => {
      if (!data) {
        throw new Error("No data returned from palyance");
      }

      if (data.errorMessage?.startsWith("Wallet not found")) {
        return Promise.reject(data.errorMessage);
      }

      return data;
    });
  }

  static getOgoneStatus(authorizationId) {
    return new Promise((resolve, reject) => {
      try {
        const url = `${process.env.VUE_APP_PALYANCE_API_BASE_URL}/ogone/waiting?authorizationId=${encodeURIComponent(authorizationId)}`;

        axios.get(url).then(
          ({ data }) => {
            if (!data || !data.status) {
              return reject(data);
            }

            resolve(data);
          },
          (error) => {
            reject(error);
          },
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  static getOgoneStatusByOrderId(orderId) {
    return new Promise((resolve, reject) => {
      try {
        const url = `${process.env.VUE_APP_PALYANCE_API_BASE_URL}/ogone/waiting?orderId=${encodeURIComponent(orderId)}`;

        axios.get(url).then(
          ({ data }) => {
            if (!data || !data.status) {
              return reject(data);
            }

            resolve(data);
          },
          (error) => {
            reject(error);
          },
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  static hasClientValidatedDoubleOptin(orderId) {
    const url = `${process.env.VUE_APP_PALYANCE_API_BASE_URL}/aspsp/double-optin?orderId=${encodeURIComponent(orderId)}`;

    return axios.get(url).then(({ data }) => {
      if (!data) {
        throw new Error("No data returned from palyance");
      }

      return data;
    });
  }

  static postToken(orderId, token) {
    const url = `${process.env.VUE_APP_PALYANCE_API_BASE_URL}/aspsp/double-optin-code`;

    return axios
      .post(url, {
        orderId,
        digitConfirmation: token,
        signedAt: Date.now(),
      })
      .then(({ data }) => {
        if (!data) {
          throw new Error("No data returned from palyance");
        }

        return data;
      });
  }
}
